import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSweetalert2 from "vue-sweetalert2";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "./registerModule";
import "./_styles.scss";
import * as VueGoogleMaps from "vue2-google-maps";
import vuetify from "./plugins/vuetify";
import "vuetify/dist/vuetify.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
const VueScrollTo = require("vue-scrollto");
import Toasted from "vue-toasted";
import "vue-search-select/dist/VueSearchSelect.css";
import i18n from "./i18n";
Vue.use(VueScrollTo);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAouz8rFGlw0mzOwrryd4_ZY0ZYSPq-m-o",
    libraries: "places",
  },
});

let toastOption = {
  theme: "toasted-primary",
  position: "top-right",
  duration: 3000,
  singleton: true,
  action: {
    text: "Cancel",
    // onClick: (e: any, toastObject: any) => {
    //   toastObject.goAway(0);
    // }
  },
};

Vue.use(VueSweetalert2);
Vue.config.productionTip = false;

Vue.use(
  VueAxios,
  axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
  }),
);

Vue.axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(
      `${process.env.VUE_APP_TENANT}:access_token`,
    );
    //  const token = process.env.VUE_APP_TOKEN;
    if (token != null) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // else {
    // }
    config.headers["x-encrypted-key"] = process.env.VUE_APP_TENANT;
    config.headers["Content-Type"] = "application/json";
    // config.headers["t-id"] = process.env.VUE_APP_TENANT;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyCSr5iceLXsKPvRRZ2M1JtW-1fw0v2HZSo",
  authDomain: "fastforge-dev-692e5.firebaseapp.com",
  projectId: "fastforge-dev-692e5",
  storageBucket: "fastforge-dev-692e5.firebasestorage.app",
  messagingSenderId: "732380005579",
  appId: "1:732380005579:web:8f87353b512db18c78474e",
  measurementId: "G-2FRBF2GR2M",
};

// Initialize Firebase
initializeApp(firebaseConfig);
Vue.use(Toasted, toastOption);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(vuetify);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
